<template>
  <app-page :title="$t('@customerList/title')" wide>
    <v-layout>
      <v-flex xs12>
        <section>
          <errors-list :errorMessage="errorMessage" />

          <v-data-table
            :headers="headers"
            :items="items"
            :loading="loading"
            :rows-per-page-items="rowsPerPageItems"
            :total-items="pagination.totalItems"
            :pagination.sync="pagination"
          >
            <v-progress-linear slot="progress" color="blue" indeterminate></v-progress-linear>
            <template slot="items" slot-scope="props">
              <tr
                class="link"
                @click="redirectToCostumerDetails(props.item.id)"
                :id="props.item.id"
              >
                <td>{{ props.item.firstName }}</td>
                <td>{{ props.item.lastName }}</td>
                <td>{{ defaultDateTimeFormatter(props.item.createdAt) }}</td>
                <td class="justify-end align-center layout pr-2 pl-1">
                  <v-btn
                    depressed
                    small
                    class="ma-0 mr-1"
                    v-for="(col, index) in props.item.insurances"
                    :key="index + col.id"
                    @click.stop="redirectToContract(col.internalId)"
                  >
                    {{ productGroupsEnum[col.productGroup] }}
                  </v-btn>
                </td>
              </tr>
            </template>
          </v-data-table>
        </section>
      </v-flex>
    </v-layout>
  </app-page>
</template>

<script>
import moment from 'moment';
import { serializeQuery, defaultDateTimeFormatter } from '../../utils';
import { getErrorMessage } from '../../errorHandlers';
import ErrorsList from '../../components/ErrorsList';

export default {
  components: { ErrorsList },

  data() {
    return {
      headers: [
        {
          text: this.$t('@customerList/firstNameColumnHeader'),
          value: 'firstName',
        },
        {
          text: this.$t('@customerList/lastNameColumnHeader'),
          value: 'lastName',
        },
        {
          text: this.$t('@customerList/createdAtColumnHeader'),
          value: 'created',
        },
        {
          text: this.$t('@customerList/activeInsurancesColumnHeader'),
          value: 'insurances',
          sortable: false,
          width: 200,
        },
      ],
      params: {
        from: moment()
          .startOf('month')
          .startOf('day')
          .format(),
      },
      items: [],
      pagination: {
        descending: true,
        page: 1,
        rowsPerPage: 15,
        sortBy: 'created',
        totalItems: 0,
      },
      rowsPerPageItems: [10, 15, 50, 100],
      loading: false,
      errorMessage: '',
      moment,
      productGroupsEnum: {
        TF: this.$t('@customerList/customersTfInsuranceLinkText'),
        OF: this.$t('@customerList/customersOfInsuranceLinkText'),
        SF: this.$t('@customerList/customersSfInsuranceLinkText'),
      },
      defaultDateTimeFormatter,
    };
  },

  watch: {
    filters() {
      this.fetchData();
    },

    pagination() {
      this.fetchData();
    },
  },

  computed: {
    query() {
      const skip = (this.pagination.page - 1) * this.pagination.rowsPerPage;
      const take = this.pagination.rowsPerPage;
      const query = {
        ...this.filters,
        skip,
        take,
      };

      if (this.pagination.sortBy) {
        query.sortBy = `customer.${this.pagination.sortBy}`;
        query.sortOrder = this.pagination.descending ? 'DESC' : 'ASC';
      } else {
        delete query.sortBy;
        delete query.sortOrder;
      }

      if (!query.from) {
        query.from = moment()
          .startOf('month')
          .startOf('day')
          .format();
      }
      return query;
    },
  },

  methods: {
    redirectToContract(internalId) {
      this.$router.push(`/contract/${internalId}`);
    },

    redirectToCostumerDetails(customerId) {
      this.$router.push(`/customers/${customerId}`);
    },

    async fetchData(force) {
      const qs = serializeQuery(this.query);
      if (!force && (this.lastQueryString === qs || this.loading)) {
        return;
      }

      try {
        this.loading = true;
        this.$emit('beforeRequest', this.query);

        const { skip, take } = this.query;
        const { data } = await this.$http.get(`/api/customers?${qs}`);

        this.items = data;

        this.lastQueryString = qs;

        if (data.length === Number(take)) {
          this.pagination.totalItems = skip + take + 1;
          this.pagination.skip = take;
        }
        this.errorMessage = '';
      } catch (e) {
        this.errorMessage = getErrorMessage(e);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
>>> td .v-btn {
  min-width: 40px;
  font-size: 12px;
}
</style>
